import React, {useEffect, useState} from "react";
import {Grid, Paper} from "@mui/material";
import {useDispatch, useSelector} from "react-redux";
import EnhancedTextField from "../enhanced/EnhancedTextField";
import EnhancedConfirmButton from "../enhanced/EnhancedConfirmButton";
import alertHelper from "../../helpers/alertHelper";
import {emailValidator} from "../../helpers/emailValidator";
import {resetPassword} from "../../features/usersSlice";
import {ArrowBack} from "@mui/icons-material";
import EnhancedIconButton from "../enhanced/EnhancedIconButton";
import {useHistory} from "react-router-dom";

function ResetPassword(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const [formState, setFormState] = useState({});
    const resetPasswordResponse = useSelector((state) => state.users.resetPasswordResponse);
    const [isResetPasswordSent, setResetPasswordSent] = useState(false);

    useEffect(() => {
        if (isResetPasswordSent && resetPasswordResponse[0] === "OK") {
            alertHelper.successDialog({
                title: "Váš požadavek byl odeslán",
                message: "Požadavek na změnu hesla byl odeslán, zkontrolujte vaši emailovou schránku. Tuto stránku můžete zavřít.",
            });
            setResetPasswordSent(false);
        }
    }, [isResetPasswordSent, resetPasswordResponse, setResetPasswordSent]);

    function handleChange(event) {
        event.persist();
        setFormState((formState) => ({
            ...formState,
            [event.target.name]: event.target.value
        }));
    }

    const resetPasswordHandle = () => {
        if (formState.email === '') {
            alertHelper.error({ message: "Musíte zadat email!" });
            return false;
        }

        if (!emailValidator(formState.email)) {
            alertHelper.error({ message: "Email není ve správném tvaru" });
            return false;
        }

        var apiData = {
            'email': formState.email
        }
        dispatch(resetPassword(apiData));
        setResetPasswordSent(true);
        setFormState({});
    }

  return (
    <div>
      <Paper>
        <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ marginTop: 0, padding: 5 }}
        >
            <div>
                <Grid container spacing={3}>
                    <Grid sx={{float: "left"}} item xs={12}>
                        <EnhancedIconButton ariaLabel="back icon" tooltip="Zpět" Icon={ArrowBack} onClick={() => history.push("/")} />
                    </Grid>
                    <Grid item xs={12}>
                        <h2>Zadejte email</h2>
                    </Grid>
                    <Grid item xs={12}>
                        <EnhancedTextField
                            name="email"
                            value={formState.email}
                            label="Email"
                            onChange={handleChange}
                            maxLength="90"
                            type="email"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <EnhancedConfirmButton
                            handleOk={resetPasswordHandle}
                            okLabel="Obnovit heslo"
                            disabledOk={!emailValidator(formState.email)}
                        />
                    </Grid>
                </Grid>
            </div>
        </Grid>
      </Paper>
    </div>
  );
}

export default ResetPassword;
